
import { Box } from '@mui/material'
import { GridColDef, GridRenderCellParams, GridValueGetter } from '@mui/x-data-grid-pro'

const stringColumns = [
  { field: 'street', headerName: 'Street', width: 100, hide: true },
  { field: 'city', headerName: 'City', width: 150, hide: true },
  { field: 'state', headerName: 'State', width: 50, hide: true },
  { field: 'zip', headerName: 'Zip', width: 50, hide: true },
  { field: 'cmsUsed', headerName: 'CMS', width: 50, hide: true },
  { field: 'source', headerName: 'Source', width: 50, hide: true },
]

export const renderStringColumns = (): GridColDef[] => {
  return stringColumns.map(channel => ({
    field: channel.field,
    headerName: channel.headerName,
    minWidth: (channel as any).minWidth,
    // flex: channel.flex,
    headerAlign: 'center',
    disableColumnMenu: true,
    valueGetter: (_value, row): GridValueGetter => {
      return row?.[channel.field] ?? ''
    },
    renderCell: (params: GridRenderCellParams) => {
      return <Box>{params && params.value ? params.value : '–'}</Box>
    },
  }))
}
